import ApiService from './api.service'

const RoleService = {
  async removeRelatedData(id) {
    try {
      return await ApiService.delete(`roles/${id}/delete-related-data`)
    } catch (error) {
      return error.response
    }
  },

  async saveRole(data, id) {
    try {
      return await ApiService.put(`roles/${id}/update`, data)
    } catch (error) {
      return error
    }
  },

  async roles() {
    try {
      return await ApiService.get('roles')
    } catch (error) {
      return error
    }
  },

  async rolesSelect() {
    try {
      return await ApiService.get('roles/select')
    } catch (error) {
      return error
    }
  },

  async rolesUsers(id) {
    try {
      return await ApiService.get('roles/' + id + '/users')
    } catch (error) {
      return error
    }
  },

  async role(id) {
    try {
      return await ApiService.get('roles/' + id)
    } catch (error) {
      return error
    }
  }
}

export { RoleService }
